import React, { ChangeEvent, useEffect, useState } from 'react';
import { CurrencyInputProps } from './interface';
import Input from 'components/Input';

export const CurrencyInput: React.FC<CurrencyInputProps> = (props) => {
  const {
    value,
    setValue,
    id,
    name,
    placeholder,
    required,
    isEditing
  } = props;

  const [valueCurrency, setValueCurrency] = useState<string>('');

  const moneyMask = (currencyValue: string) => {
    currencyValue = currencyValue.replace('.', '').replace(',', '').replace(/\D/g, '');

    if (currencyValue !== '') {
      const options = { minimumFractionDigits: 2 };
      const result = new Intl.NumberFormat('pt-BR', options).format(
        parseFloat(currencyValue) / 100
      );

      setValueCurrency(`R$ ${result}`);
      setValue(result);
    }
  };

  const moneyMaskEditing = (currencyValue: string) => {
    if (currencyValue !== '') {
      currencyValue = currencyValue.replace(',', '.');

      const options = { minimumFractionDigits: 2 };
      const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(currencyValue));

      setValueCurrency(`R$ ${result}`);
      setValue(result);
    }

    return '';
  };

  useEffect(() => {
    if (isEditing) {
      moneyMaskEditing(value);
    }
  }, []);

  return (
    <Input
      id={id}
      name={name}
      type="text"
      required={required}
      className="w-100"
      placeholder={placeholder}
      value={valueCurrency}
      onChange={(e: ChangeEvent<HTMLInputElement>) => moneyMask(e.target.value)}
      customValidate={true}
    />
  );
};